<template>
  <div class="my-applications">
    <div class="page-header">
      <div class="title">
        <i class="el-icon-money"></i>
        <span>退款申请表单</span>
      </div>
    </div>

    <!-- 退款申请表单 -->
    <el-form ref="refundForm" :model="formData" :rules="rules" label-width="100px" class="refund-form">
      <div class="form-layout">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="支付截图" prop="paymentImage" class="upload-form-item">
              <el-upload class="upload-area" action="/api/api/v1/upload/file" 
               :on-success="handleUploadSuccess"
                :headers="uploadHeaders"  name="file"  :on-remove="handleRemove" 
                :before-upload="beforeUpload" 
                :on-preview="handlePictureCardPreview"
                list-type="picture-card" :limit="1" drag>
                <i class="el-icon-plus"></i>
              </el-upload>

             
              <!-- 图片预览对话框 -->
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
          <!-- 左侧信息栏 -->
          <el-col :span="18">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="来源渠道" prop="channel" class="compact-form-item">
                  <el-select v-model="formData.channel" placeholder="请选择来源渠道" style="width: 100%"
                    @change="handleSourceChannelChange">
                    <el-option v-for="item in sourceChannelList" :key="item.itemValue" :label="item.itemLabel"
                      :value="item.itemValue">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交易单号" prop="orderNo" class="compact-form-item">
                  <el-input v-model="formData.orderNo" placeholder="请输入交易单号" @input="debounceOrderNoInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="支付时间" prop="paymentTime" class="compact-form-item">
                  <el-date-picker v-model="formData.paymentTime" type="datetime" placeholder="选择支付时间"
                    style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交易类型" prop="transactionType" class="compact-form-item">
                  <el-input v-model="formData.transactionType" placeholder="交易类型" style="width: 100%" readonly>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <!-- 充值金额记录表格 -->
      <!-- <refund-management v-if="formData.transactionType && formData.transactionType === '余额支付'" :records="formData.records" :orderData="formData"></refund-management>
      <wetCatPay v-if="formData.transactionType && formData.transactionType === '微信支付'" :records="formData.records" :orderData="formData"></wetCatPay> -->

      <refund-management v-if="formData.transactionType === '充值订单'" :records="formData.records" :orderData="formData"></refund-management>
      <wetCatPay v-if="formData.transactionType === '线上购买'" :records="formData.records" :orderData="formData"></wetCatPay> 
      
      <!-- 退款信息部分（从godaddy.vue整合） -->
      <div class="refund-info">
        <div class="form-title">
          <i class="el-icon-document"></i>
          <span>退款信息</span>
        </div>
        
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="ICCID" prop="cardId">
              <el-input v-model="formData.cardId" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="接待日期" prop="receptionDate">
              <el-input v-model="formData.receptionDate" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="登记人" prop="registrant">
              <el-input v-model="formData.registrant" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="所属团队" prop="teamId">
              <el-cascader 
                v-model="formData.teamId" 
                :options="teamTreeData" 
                :props="{
                  checkStrictly: true,
                  value: 'value',
                  label: 'label',
                  emitPath: false,
                  expandTrigger: 'click'
                }" 
                clearable 
                placeholder="请选择所属团队" 
                style="width: 100%" 
                @change="handleTeamChange"
                :show-all-levels="false"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="代理层级" prop="agentThreeName">
              <el-input v-model="formData.agentThreeName" placeholder="请选择代理层级" style="width: 100%" disabled>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可退金额" prop="refundAmount">
              <el-input v-model="formData.refundAmount" suffix-icon="el-icon-coin">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="退款路径" prop="refundPath" label-width="100px">
              <el-select v-model="formData.refundPath" placeholder="请选择退款路径" style="width: 100%">
                <el-option label="原路退回" value="原路退回"></el-option>
                <el-option label="支付宝" value="支付宝"></el-option>
                <el-option label="微信" value="微信"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款申请人" prop="refundApplicant" label-width="100px">
              <el-input v-model="formData.refundApplicant" placeholder="请输入收款申请人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款账号" prop="accountNumber" label-width="100px">
              <el-input v-model="formData.accountNumber" placeholder="请输入收款账号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="退款原因" prop="refundReason">
              <el-input type="textarea" v-model="formData.refundReason" rows="3" placeholder="请输入退款原因"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      
      <!-- 底部按钮 -->
      <div class="form-buttons">
        <el-button type="primary" @click="submitForm('refundForm')">保存</el-button>
        <el-button @click="resetForm('refundForm')">重置</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import RefundManagement from './RefundManagement.vue'
import WetCatPay from '@/views/refund/wetCatPay/wetCatPay.vue'
import { getDictData } from '@/api/dict'
import request from '@/utils/request'
import { mapGetters } from 'vuex'

export default {
  name: 'MyRefundApplications',
  components: {
    RefundManagement,
    WetCatPay,
  },
  data() {
    return {
      formData: {
        id:undefined,
        channel: '',
        channelName: '',
        paymentImage: '',
        orderNo: '',
        transactionType: '',
        agentName: '',
        cardId: '',
        paymentTime: '',
        giftMoney: 0,
        rechargeMoney: 0,
        wxOrderId: '',
        records: [],
        registrant: '',
        teamId: '',
        teamName: '',
        // 从godaddy.vue整合的字段
        receptionDate: new Date().toLocaleString(),
        refundAmount: '0.00',
        refundPath: '原路退回',
        refundApplicant: '',
        accountNumber: '',
        refundReason: '',
        agentLevel: '22222', // 代理层级
        orderNumber:''//线上购买时候的订单号
      },
      uploadHeaders: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      sourceChannelList: [],
      teamList: [],
      teamTreeData: [],
      dialogImageUrl: '',
      dialogVisible: false,
      orderNoTimer: null,
      rules: {
        channel: [
          { required: true, message: '请选择来源渠道', trigger: 'change' }
        ],
        // paymentImage: [
        //   { required: true, message: '请上传支付截图', trigger: 'change' }
        // ],
        paymentTime: [
          { required: true, message: '请选择支付时间', trigger: 'change' }
        ],
        orderNo: [
          { required: true, message: '请输入交易单号', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        transactionType: [
          { required: true, message: '请选择交易类型', trigger: 'change' }
        ],
        // 从godaddy.vue整合的验证规则
        refundPath: [
          { required: true, message: '请选择退款路径', trigger: 'change' }
        ],
        // refundApplicant: [
        //   { required: true, message: '请输入收款申请人', trigger: 'blur' }
        // ],
        // accountNumber: [
        //   { required: true, message: '请输入收款账号', trigger: 'blur' }
        // ],
        refundReason: [
          { required: true, message: '请输入退款原因', trigger: 'blur' }
        ],
          agentThreeName: [
          { required: true, message: '请选择代理层级', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo'
    })
  },
  async created() {
    // 从路由参数获取id
    if (this.$route.query.id) {
      this.formData.id = this.$route.query.id;
      console.log('从URL获取到ID:', this.formData.id);
      // 根据ID获取申请详情
      await this.fetchRefundDetail(this.formData.id);
      this.fetchOrderData(this.formData.orderNo);
      
    }
    
    // 确保配置加载完成
    this.loadConfig().then(() => {
      // 如果有初始来源渠道，设置对应的紧急程度
      if (this.formData.channel) {
        this.setUrgencyLevel(this.formData.channel);
      }
    });
    
    // 设置登记人信息
    this.setUserInfo();
    
    // 确保上传headers正确设置
    this.uploadHeaders = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    };
  },
  methods: {
    // 根据ID获取退款申请详情
    async fetchRefundDetail(id) {
      try {
        console.log('获取退款申请详情, ID:', id);
        this.$loading({
          lock: true,
          text: '加载数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        const response = await request({
          url: '/api/v1/kf-refound/apply-detail',
          method: 'POST',
          data: {
            id: parseInt(id)
          }
        });
        
        this.$loading().close();
        
        if (response && response.status === 1 && response.data) {
          const data = response.data;
          console.log('获取到的退款申请详情:', data);
          
          // 填充表单数据
          this.formData = {
            ...this.formData,
            id: data.id,
            channel: data.source_channel || '',
            channelName: data.source_channel_name || '',
            paymentImage: data.payment_screenshot || '',
            orderNo: data.payment_order_no || '',
            transactionType: data.refund_type === 1 ? '线上购买' : '充值订单',
            paymentTime: data.payment_time ? new Date(data.payment_time) : '',
            cardId: data.card_no || '',
            receptionDate: data.reception_date || new Date().toLocaleString(),
            registrant: data.create_by || this.formData.registrant,
            teamId: data.team_id || '',
            teamName: data.team || '',
            agentThreeName: data.agent_level || '',
            refundAmount: data.refundable_amount ? data.refundable_amount + ' 元' : '0.00 元',
            refundPath: data.refund_path || '原路退回',
            refundApplicant: data.applicant || '',
            accountNumber: data.refund_channel || '',
            refundReason: data.refund_reason || '',
            orderNumber:data.my_order_number || ''
          };
          
          // 根据代理人名称设置团队
          if (this.formData.agentThreeName && this.formData.agentThreeName.indexOf('杨松叶') > -1) {
            this.formData.teamId = '1302001';
            this.formData.teamName = '白云团队';
          } else if (this.formData.agentThreeName) {
            this.formData.teamId = '1302002';
            this.formData.teamName = '本部营销团队';
          }
         
          
          this.$message.success('加载退款申请数据成功');
        } else {
          this.$message.error(response?.msg || '获取退款申请详情失败');
        }
      } catch (error) {
        this.$loading().close();
        console.error('获取退款申请详情出错:', error);
        this.$message.error('获取退款申请详情失败: ' + (error.message || '未知错误'));
      }
    },
    // 处理输入交易单号，使用防抖函数
    debounceOrderNoInput(value) {
      // 清除之前的定时器
      if (this.orderNoTimer) {
        clearTimeout(this.orderNoTimer);
      }
      
      // 设置新的定时器，500毫秒后执行查询
      this.orderNoTimer = setTimeout(() => {
        if (value && value.trim() !== '') {
          this.fetchOrderData(value);
        }
      }, 500);
    },
    // 设置用户信息
    setUserInfo() {
      // 从Vuex获取用户信息
      if (this.userInfo) {
        // 优先使用realName，如果没有则使用name
        this.formData.registrant = this.userInfo.realName || this.userInfo.name || '系统用户';
        console.log('设置登记人为:', this.formData.registrant);
      } else {
        // 尝试从localStorage获取
        try {
          const userInfoStr = localStorage.getItem('userInfo');
          if (userInfoStr) {
            const userInfo = JSON.parse(userInfoStr);
            this.formData.registrant = userInfo.realName || userInfo.name || '系统用户';
            console.log('从localStorage设置登记人为:', this.formData.registrant);
          }
        } catch (error) {
          console.error('获取用户信息失败:', error);
          this.formData.registrant = '系统用户';
        }
      }
    },
    // 提交表单
    submitForm(formName) {
      console.log('提交表单',this.formData);
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            // 显示加载状态
            this.$loading({
              lock: true,
              text: '提交中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });

            if(this.formData.orderNumber==this.formData.orderNo){
              this.formData.orderNumber=""
            }
            // 准备请求数据
            const requestData = {
              "refund_type": this.formData.transactionType === '充值订单' ? 2 : 1, // 1-套餐购买 2-充值订单
              "order_no":this.formData.orderNumber || "",//线上购买时候的订单号
              "reception_date": (() => {
                const now = new Date();
                const utc8Date = new Date(now.getTime() + (8 * 60 * 60 * 1000)); // 转换为东八区时间
                return utc8Date.toISOString().replace('T', ' ').substring(0, 19);
              })(), // 接待时间使用东八区时间
              "source_channel": this.formData.channelName || this.getSourceChannelName(this.formData.channel) || "", // 来源渠道名称
              "card_no": this.formData.cardId || "", // ICCID号
              "team": this.formData.teamName || "", // 所属团队名称
              "agent_level": this.formData.agentThreeName || "未分配", // 代理层级
              "payment_screenshot": this.formData.paymentImage || "", // 支付截图
              "payment_time": this.formData.paymentTime ? new Date(this.formData.paymentTime).toISOString().replace('T', ' ').substring(0, 19) : new Date().toISOString().replace('T', ' ').substring(0, 19), // 客户支付时间
              "payment_order_no": this.formData.orderNo || "", // 客户支付单号，直接使用orderNo字段，不再区分交易类型
              "refundable_amount": parseFloat(String(this.formData.refundAmount).replace(/[^\d.]/g, '')) || 0, // 退款金额，从表单中获取
              "refund_path": this.formData.refundPath || "原路退回", // 退款路径
              "refund_channel": this.formData.accountNumber || "", // 收款账号
              "refund_reason": this.formData.refundReason || "设备无法使用", // 退款原因
              "applicant": this.formData.refundApplicant || "" // 退款申请人，直接使用用户输入的值
            };

            

            // 如果是编辑模式，添加ID字段
            if (this.formData.id) {
              requestData.id = this.formData.id;
            }

            console.log('提交退款申请请求数据:', requestData);

            // 根据是否有ID决定是新建还是更新
            const url = this.formData.id ? '/api/v1/kf-refound/apply' : '/api/v1/kf-refound/apply';
            const actionText = this.formData.id ? '更新' : '提交';

            // 发送请求
            const response = await request({
              url: url,
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
              },
              data: requestData
            });

            console.log('退款申请响应:', response);

            // 关闭加载状态
            this.$loading().close();

            if (response && response.status === 1) {
              this.$message.success(`退款申请${actionText}成功`);
              // 成功后跳转到我的申请列表页面
              this.$router.push('/refund/myApplications');
            } else {
              this.$message.error(response?.msg || `${actionText}失败，请稍后重试`);
            }
          } catch (error) {
            console.error('提交退款申请出错:', error);
            this.$message.error('提交失败: ' + (error.message || '未知错误'));
            // 关闭加载状态
            this.$loading().close();
          }
        } else {
          this.$message.error('请填写完整信息');
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 处理图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 处理上传成功
    handleUploadSuccess(response, file) {
      console.log('上传响应:', response);
      
      // 直接使用response.data.filename
      if (response && response.data && response.data.filename) {
        this.formData.paymentImage = response.data.filename;
        console.log('设置支付截图文件名:', this.formData.paymentImage);
        this.$message.success('上传成功');
        return;
      }
      
      // 检查是否有list数据结构
      if (response && response.data && response.data.list && Array.isArray(response.data.list) 
      && response.data.list.length > 0) {
        const firstItem = response.data.list[0];
        if (firstItem && firstItem.image_url) {
          this.formData.paymentImage = firstItem.image_url;
          console.log('从list中设置支付截图URL:', this.formData.paymentImage);
          this.$message.success('上传成功');
          return;
        }else{
          this.$message.error('上传失败');
        }
      }

    },
    // 处理图片删除
    handleRemove() {
      this.formData.paymentImage = '';
    },
    // 上传前校验
    beforeUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPGOrPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    // 设置来源渠道channel
    setSourceChannel(channel) {
      this.formData.channel = channel;
      this.formData.channelName = this.getSourceChannelName(channel);
    },
    // 处理来源渠道变化
    handleSourceChannelChange(value) {
      this.setSourceChannel(value);
    },

    // 获取来源渠道名称
    getSourceChannelName(code) {
      if (this.sourceChannelList && this.sourceChannelList.length > 0) {
        const channel = this.sourceChannelList.find(item => item.itemValue === code);
        if (channel) {
          console.log('找到来源渠道名称:', channel.itemLabel, '对应代码:', code);
          return channel.itemLabel;
        }
      }
      console.log('未找到来源渠道名称, 代码:', code);
      return code || '未知';
    },
    
    // 格式化交易单号，确保是简短有意义的文本
    formatOrderNo(orderNo) {
      if (!orderNo) return '';
      
      // 如果是UUID格式，生成更友好的格式
      if (typeof orderNo === 'string' && (orderNo.includes('-') || orderNo.length > 20)) {
        // 生成一个更友好的交易单号格式
        const date = new Date();
        const year = date.getFullYear().toString().substring(2);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
        
        return `TX${year}${month}${day}${random}`;
      }
      
      return orderNo;
    },

    // 根据交易单号获取凭证数据
    async fetchOrderData(orderNumber) {
      try {
        console.log('发送请求，交易单号:', orderNumber);
        
        const response = await request({
          url: '/api/v1/kf-refound/get-by-order-number',
          method: 'POST',
          data: {
            orderNumber: orderNumber,
            my_order_number:this.formData.orderNumber
          
       
          }
        });
        
        console.log('API响应数据:', response);
        
        if (response && response.status === 1) {
          const data = response.data;
          console.log('获取到的原始数据:', data);
          
          // 检查原始数据中的所有字段名称
          console.log('原始数据中的所有字段名称:', Object.keys(data));
          
          // 检查关键字段的实际值
          console.log('后端返回的关键字段:', {
            typeStr: data.typeStr,
            orderSourceStr: data.orderSourceStr,
            rsourceStr: data.rsourceStr,
            mfAmount: data.mfAmount,
            noMfAmount: data.noMfAmount,
            fandiankMoney: data.fandiankMoney,
            fandianMoney: data.fandianMoney
          });
          
          // 详细检查每条记录
          if (data.records && Array.isArray(data.records)) {
            data.records.forEach((record, index) => {
             
            });
          }
          
          // 处理records数据，确保格式正确
          let processedRecords = [];
          if (data.records && Array.isArray(data.records)) {
            processedRecords = data.records.map((record, index) => {
              // 确保每条记录都有必要的字段
              const processedRecord = {
                ...record,
                cardId: record.cardId || data.cardId || '',
                agent_name: record.agent_name || data.agentName || '',
                record_type: record.record_type || ''
              };
              console.log(`处理后的记录 ${index + 1}:`, processedRecord);
              return processedRecord;
            });
          }
         
          
          // 更新表单数据 - 映射所有API返回的字段
          this.formData = {
            ...this.formData,
            // 基本信息
            agentId: data.agentId || '',
            agentName: data.agentName || '',
            agentThreeId: data.agentThreeId || '',
            agentThreeName: data.agentThreeName || '未分配',
            teamId: data.agentThreeId || '',
            teamName: data.agentThreeName || '',
            cardId: data.cardId || '',
            // channel: data.source_channel || '',
            paymentTime: data.createDateStr || '',
            giftMoney: data.fandiankMoney || 0,
            kind: data.kind || 0,
            // orderNo: data.orderNumber || '', // 确保这是原始交易单号
            orderNumber: data.orderNumber || '', // 保留orderNumber字段以兼容原有代码
            rechargeMoney: data.rechargeMoney || 0,
            records: processedRecords,
            refundDate: data.refundDate || '',
            refundRemark: data.refundRemark || '',
            rsource: data.rsource || 0,
            rsourceStr: data.rsourceStr || '',
            orderSourceStr: data.orderSourceStr || '',
            wxOrderId: data.wxOrderId || '',
            transactionId: data.transactionId || '',
            vcode: data.vcode || '',
            orderMoney: data.orderMoney || '',
            payStatusStr: data.payStatusStr || '',
            phone: data.phone || '',
            accountName: data.accountName || '',
            mealName: data.mealName || '',
            mealTypeStr: data.mealTypeStr || '',
            effectTypeStr: data.effectTypeStr || '',
            isFirstRechargeStr: data.isFirstRechargeStr || '',
            noMfAmount: data.noMfAmount || '',
            mfAmount: data.mfAmount || '',
            costPrice: data.costPrice || '',
            createTime: data.createTime || '',
            typeStr: data.typeStr || '',
            // fandiankMoney: data.fandiankMoney || 0,
            fandianMoney: data.fandianMoney || 0,
            status: data.status || 0,
            // 保留登记人信息，不要被API返回的数据覆盖
            registrant: this.formData.registrant,
            // 设置接待日期
            receptionDate: new Date().toLocaleString() || data.reception_date,
            // 设置可退金额 - 根据交易类型设置不同的字段
            refundAmount: '0.00 元' // 默认值，下面会根据交易类型更新
          };

        
          
          console.log('更新后的formData:', this.formData);
          console.log('更新后的records:', this.formData.records);
          console.log('更新后的records长度:', this.formData.records.length);
          
          // 如果有来源渠道代码，更新来源渠道名称
          if (this.formData.channel) {
            this.formData.channelName = this.getSourceChannelName(this.formData.channel);
            console.log('更新来源渠道名称:', this.formData.channelName);
          }
          
          // 确保团队名称正确设置
          if (this.formData.teamId && !this.formData.teamName) {
            // 递归查找选中的团队信息
            const findTeam = (nodes, value) => {
              for (const node of nodes) {
                if (node.value === value) {
                  return node;
                }
                if (node.children && node.children.length > 0) {
                  const found = findTeam(node.children, value);
                  if (found) return found;
                }
              }
              return null;
            };
            
            const selectedTeam = findTeam(this.teamTreeData, this.formData.teamId) || 
                                this.teamList.find(item => item.itemValue === this.formData.teamId);
            
            if (selectedTeam) {
              this.formData.teamName = selectedTeam.label || selectedTeam.itemLabel;
              console.log('设置团队名称:', this.formData.teamName);
            }
          }

          if(this.formData.agentThreeName.indexOf('杨松叶') > -1){
            this.formData.teamId = '1302001';
            this.formData.teamName = '白云团队';
          }else{
            this.formData.teamId = '1302002';
            this.formData.teamName = '本部营销团队';
          }


          

          // if(this.formData.agentLevel.indexOf('代理') > -1){
          //   this.formData.agentLevel = '代理';
          // }else{
          //   this.formData.agentLevel = '非代理';
          // }
          
          // 根据kind设置交易类型并处理records数据
          if (data.kind === 1) {
            this.formData.transactionType = '线上购买';
            // 对于线上购买类型，使用transactionId作为交易单号
            if (data.transactionId) {
              this.formData.orderNo = data.transactionId;
              console.log('线上购买类型，使用transactionId作为交易单号:', data.transactionId);
            }
            // 使用createTime作为支付时间
            if (data.createTime) {
              this.formData.paymentTime = new Date(data.createTime);
              console.log('线上购买类型，使用createTime作为支付时间:', data.createTime);
            }
            // 线上购买类型的可退金额，优先使用orderMoney，如果没有则使用mfAmount或noMfAmount
            const refundableAmount = data.orderMoney || data.mfAmount || data.noMfAmount || 0;
            this.formData.refundAmount = refundableAmount ? refundableAmount + ' 元' : '0.00 元';
            console.log('线上购买类型，设置可退金额:', this.formData.refundAmount);
          } else if (data.kind === 2) {
            this.formData.transactionType = '充值订单';
            // 充值订单类型的可退金额，使用rechargeMoney
            this.formData.refundAmount = data.rechargeMoney ? data.rechargeMoney + ' 元' : '0.00 元';
            console.log('充值订单类型，设置可退金额:', this.formData.refundAmount);
            
            // 强制刷新组件
            this.$nextTick(() => {
             
           
            });
          }
          
          // 设置支付时间 (如果上面没有设置的话)
          if (!this.formData.paymentTime && data.createDateStr) {
            this.formData.paymentTime = new Date(data.createDateStr);
          }
          
          this.$message.success('成功获取凭证数据');
        } else {
          console.error('API响应无效:', response);
          this.$message.error('获取凭证数据失败');
        }
      } catch (error) {
        console.error('获取凭证数据出错:', error);
        this.$message.error('获取凭证数据出错: ' + (error.message || '未知错误'));
      }
    },

    //定义一个通用方法，根据类型获取字典数据
    async getDictData(_type) {
            const response = await getDictData(_type)
            if (response.status === 1) {
                return response.data
            }
        },
        async loadConfig() {
          try {
            // 获取来源渠道数据
            this.sourceChannelList = await this.getDictData('KFTSLY'); // 来源渠道
            console.log("来源渠道", this.sourceChannelList);
            
            // 获取团队数据
            const teamData = await this.getDictData('KFYXTD'); // 所属团队
            this.teamList = teamData || [];
            console.log("所属团队原始数据", this.teamList);
            
            // 处理团队数据为树形结构
            this.teamTreeData = this.transformDictDataToTree(this.teamList);
            console.log("所属团队树形数据", this.teamTreeData);
          } catch (error) {
            console.error('加载配置数据出错:', error);
            this.$message.error('加载配置数据失败');
          }
        },
         // 将字典数据转换为树形结构
         transformDictDataToTree(data) {
          if (!data || !Array.isArray(data)) return [];
          
          // 创建一个Map来存储所有节点
          const nodeMap = new Map();
          
          // 第一遍循环：创建所有节点
          data.forEach(item => {
            nodeMap.set(item.itemId, {
              id: item.itemId,
              value: item.itemValue,
              label: item.itemLabel,
              parentId: item.parentId,
              children: []
            });
          });
          
          // 第二遍循环：建立父子关系
          const rootNodes = [];
          data.forEach(item => {
            const node = nodeMap.get(item.itemId);
            
            if (item.parentId && item.parentId !== '0' && nodeMap.has(item.parentId)) {
              // 如果有父节点，将当前节点添加到父节点的children中
              const parentNode = nodeMap.get(item.parentId);
              parentNode.children.push(node);
            } else {
              // 如果没有父节点或父节点是根节点，则当前节点是根节点
              rootNodes.push(node);
            }
          });
          
          return rootNodes;
        },

        // 处理团队选择变化
        handleTeamChange(value) {
          if (!value) {
            // 如果清除选择
            this.formData.teamId = '';
            this.formData.teamName = '';
            return;
          }
          
          // 递归查找选中的团队信息
          const findTeam = (nodes, value) => {
            for (const node of nodes) {
              if (node.value === value) {
                return node;
              }
              if (node.children && node.children.length > 0) {
                const found = findTeam(node.children, value);
                if (found) return found;
              }
            }
            return null;
          };
          
          const selectedTeam = findTeam(this.teamTreeData, value) || 
                              this.teamList.find(item => item.itemValue === value);
          
          if (selectedTeam) {
            this.formData.teamId = value;
            this.formData.teamName = selectedTeam.label || selectedTeam.itemLabel;
            console.log('选择的团队:', {id: value, name: this.formData.teamName});
          }
        },
  }
}
</script>

<style lang="scss" scoped>
.my-applications {
  padding: 0px;
  background-color: #e9eff6;
  min-height: 100vh;


  .page-header {
    margin-bottom: 0px;


    .title {
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;

      i {
        margin-right: 8px;
        color: #409EFF;
      }
    }
  }

  .form-layout {
    margin: 0px;
    padding: 0px;
    border-bottom: 1px solid #EBEEF5;

    .el-row {
      margin-bottom: 0;

    }
  }

  :deep(.compact-form-item) {
    margin-bottom: 18px;

    .el-form-item__label {
      padding: 0 12px 0 0;
      line-height: 32px;
      width: 100px !important;
      text-align: right;
    }

    .el-form-item__content {
      line-height: 32px;
      margin-left: 100px !important;
    }
  }

  .upload-form-item {
    height: 100%;
    display: flex;
    margin-bottom: 0;

    :deep(.el-form-item__label) {
      width: 100px !important;
      text-align: right;
    }

    :deep(.el-form-item__content) {
      margin-left: 100px !important;
      flex: 1;
    }
  }

  .upload-area {
    :deep(.el-upload--picture-card) {
      width: 80px;
      height: 80px;
      line-height: 80px;
      margin: 0;
    }

    :deep(.el-upload-list--picture-card) {
      .el-upload-list__item {
        width: 70px;
        height: 70px;
        margin: 0 8px 0 0;
      }
    }
  }

  .form-buttons {
    text-align: center;
    margin-top: 0px;
    padding-top: 0px;

  }

  :deep(.el-upload-dragger) {
    width: 80%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :deep(.prepaid-credit) {
    margin-top: 0px;

  }
}
:deep(.el-table th) {
 background-color: #93b3e4!important;
}
:deep(.el-table td) {
  background-color: #d1e0f7!important;
  
}

/* 从godaddy.vue整合的样式 */
.refund-info {
  margin-top: 20px;
  background-color: #e3ebf4;
  border-radius: 4px;
  padding: 10px;

  .form-title {
    
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    color: #363739;

    i {
      margin-right: 6px;
      font-size: 16px;
    }
  }
  
  // 确保表单项标签宽度足够显示完整文字
  :deep(.el-form-item__label) {
    min-width: 100px;
    white-space: nowrap;
    text-align: right;
  }
  
  :deep(.el-form-item__content) {
    margin-left: 100px !important;
  }
  
  // 调整禁用输入框的样式
  :deep(.el-input.is-disabled .el-input__inner) {
    color: #303133;
    font-weight: 500;
    background-color: #f5f7fa;
    border-color: #dcdfe6;
  }
}

// 全局调整禁用输入框的样式
:deep(.el-input.is-disabled .el-input__inner) {
  color: #303133;
  font-weight: 500;
  background-color: #f5f7fa;
}
</style>